import { Moment } from 'moment';

export const enum ExportStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

export enum ExportType {
  SERVICE_NOW = 'SERVICE_NOW',
  JIRA = 'JIRA',
}

export class BatchExport {
  constructor(
    private readonly exportType: ExportType,
    private readonly status: ExportStatus,
    private readonly totalCount: number,
    private readonly exportedCount: number,
    private readonly createdAt: Moment,
    private readonly canceledAt: Moment | null
  ) {}

  public getType() {
    return this.exportType;
  }

  public getStatus() {
    return this.status;
  }

  public getTotalCount() {
    return this.totalCount;
  }

  public getExportedCount() {
    return this.exportedCount;
  }

  public getCreatedAt() {
    return this.createdAt;
  }

  public getCanceledAt() {
    return this.canceledAt;
  }

  public isRunning() {
    return [ExportStatus.PENDING, ExportStatus.IN_PROGRESS].includes(this.status);
  }

  public isCanceled() {
    return this.status === ExportStatus.CANCELED;
  }

  public isCompleted() {
    return this.status === ExportStatus.COMPLETED;
  }

  public isFinished() {
    return [ExportStatus.CANCELED, ExportStatus.COMPLETED].includes(this.status);
  }

  public getProgress() {
    return Math.round((this.getExportedCount() / this.getTotalCount()) * 100);
  }
}
